export default "__VITE_ASSET__DaoGnsHS__"